import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const RadixMenu = ({ 
    trigger, 
    items, 
    className = "",
    side = "bottom",
    align = "end",
    sideOffset = 8,
    alignOffset = 0,
    width = "w-56"
}) => {
    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                {React.cloneElement(trigger, {
                    className: `${trigger.props.className || ''} focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2`
                })}
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className={`${width} bg-base-100 rounded-lg shadow-xl border border-base-300 overflow-hidden z-[9999] animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95`}
                    sideOffset={sideOffset}
                    alignOffset={alignOffset}
                    side={side}
                    align={align}
                    collisionPadding={16}
                >
                    <div className="py-1">
                        {items.map((item, index) => (
                            <div key={index}>
                                {item.divider ? (
                                    <div className="border-t border-base-200 my-1" />
                                ) : (
                                    <DropdownMenu.Item
                                        onClick={item.onClick}
                                        disabled={item.disabled}
                                        className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-150 focus:outline-none focus:bg-base-200 ${
                                            item.danger 
                                                ? 'text-error hover:bg-error hover:text-error-content focus:bg-error focus:text-error-content' 
                                                : 'text-base-content hover:bg-base-200'
                                        } ${item.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {item.icon && (
                                            <span className="flex-shrink-0 w-4 h-4">
                                                {item.icon}
                                            </span>
                                        )}
                                        <span className="flex-1 text-left">{item.label}</span>
                                        {item.shortcut && (
                                            <span className="text-xs opacity-60 ml-2">
                                                {item.shortcut}
                                            </span>
                                        )}
                                        {item.submenu && (
                                            <ChevronRightIcon className="w-4 h-4 ml-auto" />
                                        )}
                                    </DropdownMenu.Item>
                                )}
                            </div>
                        ))}
                    </div>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};

export default RadixMenu; 